<div class="popup">
  <div class="popup__header">
    <i class="material-icons popup__icon">receipt_long</i>
    <h2 class="popup__title" mat-dialog-title>{{description}}</h2>
  </div>

  <mat-dialog-content class="popup__content">
    <div class="popup__error" *ngIf="errorMessage">
      <i class="material-icons">error_outline</i>
      <span>{{errorMessage}}</span>
    </div>

    <div class="popup__field">
      <i class="material-icons popup__field-icon">person</i>
      <input class="popup__input"
             type="text"
             [placeholder]="labelName || 'Enter name'"
             [(ngModel)]="inputValue"
             (keydown.enter)="submit()"
             cdkFocusInitial/>
    </div>
    <p class="popup__hint">Your name helps us identify this order.</p>
  </mat-dialog-content>

  <div class="popup__actions">
    <button class="popup__btn popup__btn--cancel" (click)="close()">
      {{ 'button.cancel' | translate }}
    </button>
    <button class="popup__btn popup__btn--submit"
            [disabled]="loading || !inputValue?.trim()"
            (click)="submit()">
      <span *ngIf="!loading">{{button_text}}</span>
      <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
    </button>
  </div>
</div>
